import { CommonModule } from "@angular/common";
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from "@angular/core";
import { ActionButtonComponent } from "../button/action-button.component";

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: "dev-portal-modal-header",

  templateUrl: "./modal-header.component.html",
  styles: [
    `
      :host {
        display: block;
      }
    `
  ],
  imports: [CommonModule, ActionButtonComponent]
})
export class ModalHeaderComponent {
  @Input() withBottomBorder = false;
  @Input() titleAlignment: "left" | "center" = "center";
  @Input() title!: string;
  @Input() leadingIcon?: string;
  @Input() trailingIcon: string | null = "/assets/icons/close.svg#img";

  @Output() clickLeading = new EventEmitter<void>();
  @Output() clickTrailing = new EventEmitter<void>();
}
